<dx-popup
    #contractEditorPopup
    width="50%"
    height="80%"
    minWidth="35%"
    minHeight="50%"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    titleTemplate="title"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'title'">
        <div class="popup-title-label">
            {{ popupTitle }}
            <sup *ngIf="helpLink" class="cc-hyperlink">
                <a [href]="helpLink" target="_blank" [class]="iconHelp"></a>
            </sup>
        </div>
    </div>
    <div *dxTemplate="let data of 'content'" class="contract-editor-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <strong>Contract Documents</strong>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-drop-down-button
                                    type="default"
                                    text="New Contract Document"
                                    hint="New Contract Document"
                                    displayExpr="name"
                                    keyExpr="id"
                                    [icon]="iconAdd"
                                    [items]="newContractDocument"
                                    (onItemClick)="onNewContractDocumentClick($event)"
                                ></dx-drop-down-button>

                                <dx-file-uploader
                                    #fileUploader
                                    labelText="Drop file here"
                                    uploadMode="useButtons"
                                    [multiple]="true"
                                    [showFileList]="false"
                                    [maxFileSize]="4000000"
                                    [visible]="false"
                                    (onValueChanged)="onAttachmentsSelect($event)"
                                ></dx-file-uploader>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #contractDocumentGrid
                        height="100%"
                        allowColumnResizing="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [dataSource]="contractDocuments"
                        (onContentReady)="onGridContentReady($event)"
                    >
                        <dxi-column
                            caption="Remove"
                            [width]="80"
                            alignment="center"
                            cellTemplate="actionCellTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="fileName"
                            dataType="string"
                            caption="Document"
                            cellTemplate="fileNameCellTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'actionCellTemplate'">
                            <dx-button
                                type="danger"
                                hint="Delete"
                                [icon]="iconDelete"
                                (onClick)="onDeleteClick(row.data)"
                            ></dx-button>
                        </div>

                        <div *dxTemplate="let row of 'fileNameCellTemplate'">
                            <div *ngIf="!!row.value" class="attachment-container">
                                <i class="cc-1-5x" [ngClass]="row.value | ccFileIcon"></i>
                                &nbsp;
                                <app-hyperlink-creator
                                    cssClass="document-name"
                                    [displayText]="row.value"
                                    (onLinkClick)="onDocumentClick(row.data)"
                                ></app-hyperlink-creator>
                            </div>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate class="contract-editor-form">
                    <dx-form
                        #contractEditorForm
                        width="100%"
                        height="100%"
                        [colCount]="1"
                        labelLocation="top"
                        [scrollingEnabled]="true"
                    >
                        <dxi-item itemType="group" [colCount]="4">
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Contract Type"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        displayExpr="displayText"
                                        valueExpr="key"
                                        [searchEnabled]="true"
                                        [dataSource]="contractEditorData.contractTypes"
                                        [(value)]="vendorContract.contractTypeCode"
                                        (onValueChanged)="onVendorContractChanged()"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Contract Term"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        displayExpr="displayText"
                                        valueExpr="key"
                                        [searchEnabled]="true"
                                        [disabled]="isContractTypeOneTime"
                                        [dataSource]="contractEditorData.contractTerms"
                                        [(value)]="vendorContract.contractTermCode"
                                        (onValueChanged)="onVendorContractTermChanged()"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Effective Date"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        type="date"
                                        [openOnFieldClick]="true"
                                        [(value)]="vendorContract.effectiveDate"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>
                            <dxi-item [isRequired]="vendorContract?.contractTermCode !== 'Perpetual'">
                                <dxo-label text="End Date"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        type="date"
                                        [openOnFieldClick]="true"
                                        [disabled]="isContractTypeRecurringAndContractTermPerpetual"
                                        [(value)]="vendorContract.endDate"
                                        (onValueChanged)="onEndDateChanged()"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="4">
                            <dxi-item [colSpan]="1">
                                <dxo-label text="Auto Renew"></dxo-label>
                                <div *dxTemplate class="auto-renew-frequecies">
                                    <dx-select-box
                                        displayExpr="displayText"
                                        valueExpr="key"
                                        [searchEnabled]="true"
                                        [disabled]="
                                            isContractTypeOneTime || isContractTypeRecurringAndContractTermPerpetual
                                        "
                                        [dataSource]="contractEditorData.autoRenewFrequencies"
                                        [(value)]="vendorContract.autoRenewalFrequencyCode"
                                    ></dx-select-box>
                                    <span>:</span>
                                    <dx-number-box
                                        [width]="45"
                                        [disabled]="
                                            isContractTypeOneTime || isContractTypeRecurringAndContractTermPerpetual
                                        "
                                        [(value)]="vendorContract.autoRenewalPeriod"
                                    ></dx-number-box>
                                </div>
                            </dxi-item>
                            <dxi-item [colSpan]="3">
                                <dxo-label text="Service Category"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        displayExpr="displayText"
                                        valueExpr="key"
                                        [searchEnabled]="true"
                                        [dataSource]="contractEditorData.serviceCategories"
                                        [(value)]="vendorContract.serviceCategoryCode"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Service Frequency"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="key"
                                    [searchEnabled]="true"
                                    [dataSource]="contractEditorData.serviceFrequencies"
                                    [(value)]="vendorContract.serviceFrequencyCode"
                                ></dx-select-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Service Description"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    [height]="60"
                                    [(value)]="vendorContract.serviceDescription"
                                ></dx-text-area>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-manage-contract-document
    *ngIf="showContractDocument"
    [communityId]="communityId"
    [communityVendorId]="communityVendorId"
    [vendorCode]="vendorCode"
    [popupTitle]="documentTitle"
    [vendorContractId]="vendorContractId"
    (onClose)="showContractDocument = false"
    (onDocumentSelect)="onDocumentSelect($event)"
></app-manage-contract-document>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
